module.exports = __webpack_public_path__ + "static/media/16UNODC8.e45b4f06.jpg";